<template>
  <div class="banner-wrapper">
    <div class="bg-landscape">
      <div class="bg-landscape-wrapper"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopImgBar'
}
</script>

<style lang="scss" scoped>
@import '~@/styles/styleConfigurations';
.banner-wrapper {
  height: 0px;
}
.bg-landscape {
  background-image: url(~@/assets/bg-landscape.jpg);
  background-position: 100% 28%;
  background-repeat: no-repeat;
  background-size: 110% 1000px;
  height: 100px;
}

.bg-landscape-wrapper {
  width: 100%;
  height: 100%;
  background-image: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.93) 50%,
    rgba(255, 255, 255, 1)
  );
}
@include media-breakpoint-down(md) {
  .bg-landscape {
    display: none;
  }
}
</style>
